import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';

/** @title Datepicker palette colors */
@Component({
  selector: 'app-date-picker',
  templateUrl: './date-picker.component.html',
  styleUrls: ['./date-picker.component.scss'],
})
export class DatePickerComponent implements OnInit {
  
  showDatePicker: boolean = false;
  @Input() list: string[];
  @Input() min: string;
  @Input() max: string;
  @Input() value: string;
  minDate: Date;
  maxDate: Date;
  selectedDate: Date;

  dateFilter;
  hasFilter: boolean = false;

  @Output() dateChange: EventEmitter<string> = new EventEmitter();

  dateToStr(date: Date) {
    return date.getFullYear() + (date.getMonth()<9 ? '-0' : '-') + (date.getMonth()+1) + (date.getDate()<10 ? '-0' : '-') + date.getDate();
  }

  ngOnInit() {
    this.minDate = new Date(this.min);
    this.maxDate = new Date(this.max);
    if (this.value != undefined) {
      this.selectedDate = new Date(this.value);
    } else {
      this.selectedDate = this.maxDate;
    }
    if (this.list != undefined) {
      this.hasFilter = true;
      this.dateFilter = (date: Date | null): boolean => {
        return this.list.includes(this.dateToStr(date));
      }
    }
    this.showDatePicker = true;
  }

  onDateChange(event: MatDatepickerInputEvent<Date>) {
    this.selectedDate = event.value;
    this.dateChange.next(this.dateToStr(this.selectedDate));
  }
}
